import React, { useCallback, useEffect, useState } from "react";
import { KFErrorScreen, KFTextInput, KFCard } from "@kf/ic2fx";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store/reducers";

import {
  clientSearchThunk,
  resetStateClient,
  setSelectedClient
} from "../../../store/slices/clientSelectionSlice";
import Loader from "../../../components/loader";
import SearchIcon from "../../../assets/icons/Search.svg";

import styles from "./ClientSelection.module.scss";
import "./ClientSelection.scss";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import {
  CountryListThunk,
  resetState
} from "../../../store/slices/countryDetailsSlice";
import { PAGE_URL } from "../../../constants/urls.constants";
import NoDataScreen from "../../Nodata";

const ClientSelection = () => {
  const { t } = useTranslation();
  const rootContainerRef = React.useRef(null) as any;
  const isConsultant = true;
  const history = useNavigate();
  const dispatch = useDispatch();
  const [filteredClients, setFilteredClients] = useState<any>();
  const [keyword, setKeyword] = React.useState("");
  const { clientsList, isClientsLoading } = useSelector((state: RootState) => {
    return state.clients;
  });
  const initSearch = (_keyword: string) => {
    const clientListStateJson: any = sessionStorage.getItem("clientsListState");
    const clientListState =
      clientListStateJson != null && JSON.parse(clientListStateJson);
    setKeyword(_keyword);
    _keyword
      ? setFilteredClients(
          clientListState.filter((client: any) => {
            return client.name.toLowerCase().includes(_keyword.toLowerCase());
          })
        )
      : setFilteredClients(clientListState);
  };

  const searchDebounce = useCallback(_.debounce(initSearch, 1000), []);

  const handleClientSelection = (client: any) => {
    history(PAGE_URL.HOME);
    dispatch(resetState());
    dispatch(CountryListThunk(client?.id));
    dispatch(setSelectedClient(client));
  };

  useEffect(() => {
    dispatch(clientSearchThunk(""));
    return () => {
      dispatch(resetStateClient());
    };
  }, []);

  useEffect(() => {
    setFilteredClients(clientsList);
    sessionStorage.setItem("clientsListState", JSON.stringify(clientsList));
  }, [clientsList]);

  const renderKFCardForClient = (item: any, i: any) => (
    <KFCard
      key={"clientTile" + i}
      className={styles.enabled}
      onKeyDown={() => {}}
      onClick={() => {
        handleClientSelection(item);
      }}
      tabIndex={item.enabled ? 0 : -1}
    >
      <h3 className={styles.clientName} title={item.name}>
        {item.name}
      </h3>

      {/* <div>
        <div className={styles.countsContainer}>
          <p className={styles.projectCount}>
            <span className={styles.count}>{item.participants}</span>{" "}
            Participants
          </p>
          <p className={styles.projectCount}>
            <span className={styles.count}>{item.projects}</span> Projects
          </p>
        </div>
      </div> */}
    </KFCard>
  );
  const renderClientList = () => {
    if (isClientsLoading) {
      return <Loader />;
    } else if (filteredClients && filteredClients.length > 0) {
      return (
        <div
          className={`${styles.cardsGrid}  ${
            filteredClients?.length == 1 && styles.centerCard
          }`}
        >
          {" "}
          {filteredClients?.map((item: any, i: any) => {
            return renderKFCardForClient(item, i);
          })}
        </div>
      );
    } else {
      return (
        <div className={styles.noDataScreen}>
          {" "}
          <NoDataScreen searchInput={keyword} />
        </div>
      );
    }
  };

  const render = () => {
    return (
      <div
        className={`${styles.clientProjectContainer}`}
        ref={rootContainerRef}
      >
        <div className={styles.searchClientContainer}>
          <h1 className={styles.title}>{t("pa.clientSelectionTitle")}</h1>
          <p className={styles.subtext}>{t("pa.clientSelectionDescription")}</p>
          <KFTextInput
            variant="standard"
            label=""
            autoComplete="off"
            autoFocus
            placeholder={t("pa.searchClientPlaceholder")}
            className={styles.multiSelectAutoComplete}
            onChange={(event) => {
              searchDebounce(event.target.value);
            }}
            InputProps={{
              startAdornment: (
                <img
                  src={SearchIcon}
                  alt="search icon"
                  style={{
                    padding: "10px 10px 10px 0px"
                  }}
                />
              )
            }}
          />
        </div>
        <div className={`${styles.clientsContainer}`}>{renderClientList()}</div>
      </div>
    );
  };

  return isConsultant ? render() : <KFErrorScreen errorType="forbidden" />;
};

export default ClientSelection;
